import React, { useCallback, useEffect, useState } from "react";
import { Table, Space, Spin, Modal, Input, Pagination, Button, Switch, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import userServiceApi from "../../../src/api/userServiceApi";
import { getRequest, postRequest, deleteRequest, putRequest } from "../../api/http";
import { toast } from "react-toastify";
import "./table.scss";
import backBtn from "../../assets/images/back-arrow.svg";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import ApprovalOrDenied from "./approvalOrDenied";
// import Button from "../../buttons/Button";
import detailsIcon from "../../assets/images/details-icon.svg";
import ViewMicrositeDetailsApproval from "./viewMicrositeDetailsApproval";
import MicrositeApprovalsTab from "./micrositeApprovalsTab";
import {
  parseMicrositePendingCount,
  PendingApprovalsTabLabel,
} from "./pendingTabLabel";
import { useLocation } from "react-router-dom";
import { inputFieldCharLimit } from "../../config";
import { PARTNER_TYPE } from "../constants";
import { PARTNER_SCOPE } from "../../api/micrositeApprovalsApi";
import { syncMicrositePendingCountsFromOverview } from "../../api/partnerMembersOverview";

const PendingApprovalTable = ({
  activeKey,
  HidependingApprovalHandler,
  getPendingOrganizationsCount,
  reloadFunction,
}) => {
  const location = useLocation();
  const lastPage = location.state.page;
  const salesType = sessionStorage.getItem("salesType");
  const navigate = useNavigate();
  const [orgId, setOrgId] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [isShowPreview, setIsShowPreview] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [partnerId, setPartnerId] = useState(false);
  const [pendingId, setPendingId] = useState();
  const [reasonValue, setReasonValue] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [top, setTop] = useState("none");
  const [bottom, setBottom] = useState("none");
  const [totalOrgs, setTotalOrgs] = useState();
  const [micrositeModalDeatilsApproval, setMicrositeModalDetailsApproval] =
    useState(false);
  sessionStorage.setItem("page", "full-pending");
  const partnerType = sessionStorage.getItem("partnerType");
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [pendingTabKey, setPendingTabKey] = useState("1");
  const [siteApprovalsCount, setSiteApprovalsCount] = useState(0);
  const [isSitePendingBadgeLoading, setIsSitePendingBadgeLoading] =
    useState(true);
  const [isOrgBadgeLoading, setIsOrgBadgeLoading] = useState(true);

  const refreshMicrositePendingBadge = useCallback(async () => {
    setIsSitePendingBadgeLoading(true);
    try {
      const partnerId = sessionStorage.getItem("partnerId");
      const counts = await syncMicrositePendingCountsFromOverview(partnerId);
      if (counts) {
        setSiteApprovalsCount(
          parseMicrositePendingCount(counts.fullMembSitePending)
        );
      }
    } finally {
      setIsSitePendingBadgeLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMicrositePendingBadge();
  }, [refreshMicrositePendingBadge]);

  const approveOrDeniedData = async (value) => {
    setIsBtnLoading(true);
    try {
      if (value == "REJECT") {
        if (!reasonValue.trim()) {
          // Check if reasonValue contains only spaces
          toast.error("Please provide a rejection reason.");
          setIsBtnLoading(false);
          return;
        }
      }
      const response = await postRequest(userServiceApi.getReviews(partnerId), {
        action: value,
        rejectionReason: reasonValue ? reasonValue : "",
      });
      if (response) {
        ClearRow();
        setIsApproveModalOpen(false);
        setIsModalOpen(false);
        setIsBtnLoading(false);
        toast.success("Approved Successfully!")
        getPendingOrganizationsCount();
        refreshMicrositePendingBadge();
        reloadFunction();
      }
    } catch (error) {
      setIsBtnLoading(false);
      toast.error(error.error);
    }
  };

  const deletePendingOrg = async (value) => {
    setIsBtnLoading(true);
    try {
      const response = await deleteRequest(
        userServiceApi.deleteOrganisation(value)
      );
      if (response) {
        setIsBtnLoading(false);
        toast.success(response);
        getPendingOrganizations();
        getPendingOrganizationsCount();
        refreshMicrositePendingBadge();
        reloadFunction();
      }
    } catch (error) {
      toast.error(error.error);
      setIsBtnLoading(false);
    }
  };

  const closeModalDetails = () => {
    setMicrositeModalDetailsApproval(false);
  };

  const Clear = () => {
    approveOrDeniedData("REJECT");
  };

  const Approve = () => {
    approveOrDeniedData("APPROVE");
  };

  const deleteHandler = () => {
    deletePendingOrg(pendingId);
    setAlertModal(false);
  };

  const handleDelete = (row) => {
    setAlertModal(true);
    setPendingId(row.id);
  };

  const showDetailsHandler = (organisationId) => {
    setOrgId(organisationId);
    // sessionStorage.setItem("modal from member or restore", "member");
    setMicrositeModalDetailsApproval(true);
    // showSearchBarHandler();
    // showTagsHandler();
    // setMicrositeId(microsite && microsite);
  };

  const handleActiveMemberChange = async(checked, id) => {
    try {
      const response = await putRequest(
        userServiceApi.updateActiveMember(id, checked),
      );
      toast.success("Updated the member successfully");
      getPendingOrganizations();
    } catch (error) {
      toast.error("Failed to update details");
    }
  }

  const smallColumns = [
    {
      title: "Organisation Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "addressOutputs",
      key: "addressOutputs",
      render: (value, row) => {
        return <p style={{
          fontSize: "17px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "200px",
          whiteSpace: "nowrap",
          display: "inline-block"
        }}>{value[0]?.street}</p>;
      },
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
      width: 150
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    ...(salesType?.toLowerCase() !== "retail"  ? [
        {
          title: PARTNER_TYPE[partnerType?.toLowerCase()] || "Members",
          key: "members",
          render: (value, row) => (
            <Switch
              className="wallpaper-switch"
              checked={row?.isActiveMember ?? false}
              onChange={(checked) =>
                handleActiveMemberChange(checked, row?.id)
              }
            />
          ),
        },
      ]
    : []),
    {
      title: "Actions",
      key: "action",
      render: (value, row, index) => (
        <Space size="middle">
          <div
            className="icon-style"
            onClick={() => showDetailsHandler(row.id)}
          >
            <img src={detailsIcon} alt="Details" />
          </div>
          <Button
            label="Deny"
            className="table-deny-btn"
            onClick={() => showDenyModal(row.id)}
          >
            Deny
          </Button>
          <Button
            label="Approve"
            className="table-approve-btn"
            onClick={() => showApproveModal(row.id)}
          >
            Approve
          </Button>
          <img className="deleteIcon" src={deleteIcon} alt="" onClick={() => handleDelete(row)} />
        </Space>
      ),
    }
  ];

  const columns = [
    {
      title: "Organisation Name",
      dataIndex: "name",
      key: "name",
      render: (t, r) => (<Space>
        <span style={{
          fontSize: "17px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "200px",
          whiteSpace: "nowrap",
          display: "inline-block"
        }}>
          {r.name}
        </span>
      </Space>)
    },
    {
      title: "Address",
      dataIndex: "addressOutputs",
      key: "addressOutputs",
      render: (value, row) => {
        return <p style={{
          fontSize: "17px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "400px",
          whiteSpace: "nowrap",
          display: "inline-block"
        }}>{value[0]?.street}</p>;
      },
    },
    {
      title: "Organisaton Website",
      dataIndex: "websiteLink",
      key: "websiteLink",
      render: (value, row) => {
        return (
          <a href={`//${value}`} style={{ color: "blue" }} target="_blank">
            <p style={{
              fontSize: "17px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "200px",
              whiteSpace: "nowrap",
              display: "inline-block"
            }}>{value}</p>
          </a>
        );
      },
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
      width: 150,

    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (value, row) => {
        return <p style={{
          fontSize: "17px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "200px",
          whiteSpace: "nowrap",
          display: "inline-block"
        }}>{row.email}</p>;
      },
    },
    ...(salesType?.toLowerCase() !== "retail"  ? [
        {
          title: PARTNER_TYPE[partnerType?.toLowerCase()] || "Members",
          key: "members",
          render: (value, row) => (
            <Switch
              className="wallpaper-switch"
              checked={row?.isActiveMember ?? false}
              onChange={(checked) =>
                handleActiveMemberChange(checked, row?.id)
              }
            />
          ),
        },
      ]
    : []),
    {
      title: "Actions",
      key: "action",
      render: (value, row, index) => (
        <Space size="middle">
          <div
            className="icon-style"
            onClick={() => showDetailsHandler(row.id)}
          >
            <img src={detailsIcon} alt="Details" />
          </div>
          <Button
            label="Deny"
            className="table-deny-btn"
            onClick={() => showDenyModal(row.id)}
          >
            Deny
          </Button>
          <Button
            label="Approve"
            className="table-approve-btn"
            onClick={() => showApproveModal(row.id)}
          >
            Approve
          </Button>
          <img className="deleteIcon" src={deleteIcon} alt="" onClick={() => handleDelete(row)} />
        </Space>
      ),
    }
  ];

  const showDenyModal = (id) => {
    setPartnerId(id);
    setIsModalOpen(true);
  };

  const showApproveModal = (id) => {
    setPartnerId(id);
    setIsApproveModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsApproveModalOpen(false);
    setAlertModal(false);
  };
  const getPendingOrganizations = async () => {
    try {
      setLoading(true);
      setIsOrgBadgeLoading(true);
      const response = await getRequest(
        userServiceApi.getPendingApprovals(pageSize, pageNumber)
      );
      // console.log(response)
      if (response.data.result) {
        setTableData(response.data.result);
        setOrgId(response.data?.result.id);
        setTotalOrgs(response.data?.totalCount);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    } finally {
      setIsOrgBadgeLoading(false);
    }
  };

  useEffect(() => {
    if (activeKey == "2" && pendingTabKey === "1") {
      getPendingOrganizations();
    }
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [activeKey, pendingTabKey]);

  const pagNumber = (number) => {
    setPageNumber(number - 1);
  };

  useEffect(() => {
    if (pendingTabKey === "1") {
      getPendingOrganizations();
    }
  }, [pageNumber, pendingTabKey]);

  const ClearRow = () => {
    getPendingOrganizations();
    setOrgId(null);
  };
  const reasonFieldChange = (e) => {
    setReasonValue(e.target.value);
  };

  const organisationsTabContent = (loading || loader) ? (
    <div className="data-loader">
      <Spin className="spin" tip="Loading" size="large" />
    </div>
  ) : (
    <>
      <div className="table-container">
        <Table
          rowClassName={() => "rowClassName1"}
          columns={window.innerWidth >= 1440 ? columns : smallColumns}
          dataSource={tableData}
          pagination={{
            position: [top, bottom],
          }}
        />
        <Pagination
          className="pagination"
          current={pageNumber + 1}
          pageSize={pageSize}
          total={totalOrgs}
          showTotal={(total) => `Pending approval for ${total} Organisations`}
          onChange={(page) => pagNumber(page)}
        />
      </div>
      {/* Deny Modal Popup Start */}
      <Modal
        className="confirmation-modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
        closable={false}
        footer={null}
      >
        <div className="message">
          <p>Are you sure you want to Deny?</p>
        </div>
        <div className="deny-reason">
          <Input.TextArea
            placeholder="Reason"
            value={reasonValue || ""}
            onChange={reasonFieldChange}
            maxLength={inputFieldCharLimit}
            rows={4}
          />
        </div>
        <div className="modalBtns">
          <Button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className="confirm-btn"
            onClick={Clear}
            loading={isBtnLoading}
          >Deny</Button>
        </div>
      </Modal>
      {/* Deny Modal Popup End */}
      {/* Approve Modal Popup Start */}
      <Modal
        className="confirmation-modal"
        open={isApproveModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
        closable={false}
        footer={null}
      >
        <div className="message">
          <p>Are you sure you want to Approve?</p>
        </div>
        <div className="modalBtns">
          <Button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="confirm-btn" onClick={Approve} loading={isBtnLoading}>
            Approve
          </Button>
        </div>
      </Modal>
      {/* Approve Modal Popup Start */}
      <Modal
        className="confirmation-modal"
        open={alertModal}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
        closable={false}
        footer={null}
      >
        <div className="message">
          <p>Are you sure you want to Delete?</p>
        </div>
        <div className="modalBtns">
          <Button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className="confirm-btn"
            onClick={deleteHandler}
            loading={isBtnLoading}
          >Delete</Button>
        </div>
      </Modal>
      {micrositeModalDeatilsApproval ? (
        <ViewMicrositeDetailsApproval
          orgId={orgId}
          closeModal={closeModalDetails}
        />
      ) : (
        <></>
      )}
    </>
  );

  return (
    <div className="tabContainer">
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="header-container">
          <div className="backbtn-container">
            <img src={backBtn} onClick={() => {
              if (lastPage === "full-members") {
                navigate('/full-members',{ state: { pendingCount: totalOrgs } })
              } else if (lastPage === "home") {
                navigate('/partner-org')
              } else {
                navigate('/partner-org')
              }
            }}
              alt="" />
            <p>Pending approvals - {PARTNER_TYPE[partnerType?.toLowerCase()] || "Members"}</p>
          </div>
        </div>
        <Tabs
          activeKey={pendingTabKey}
          onChange={setPendingTabKey}
          destroyInactiveTabPane
          items={[
            {
              key: "1",
              label: (
                <PendingApprovalsTabLabel
                  label="Organisations"
                  count={totalOrgs ?? 0}
                  loading={isOrgBadgeLoading}
                />
              ),
              children: organisationsTabContent,
            },
            {
              key: "2",
              label: (
                <PendingApprovalsTabLabel
                  label="Site Approvals"
                  count={siteApprovalsCount}
                  loading={isSitePendingBadgeLoading}
                />
              ),
              children: (
                <MicrositeApprovalsTab
                  partnerScope={PARTNER_SCOPE.MEMBERS}
                  isActive={pendingTabKey === "2"}
                  onReviewSuccess={refreshMicrositePendingBadge}
                />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};
export default PendingApprovalTable;
